var _circle, _path, _path2, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPermitsLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 40.4858,
    r: 27,
    fill: "#33D085"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 13.4858H67V55.4858L30.5 53.4858L29 13.4858Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3571 7.90619H34.6786C33.1725 7.90619 31.7282 8.52845 30.6632 9.63608C29.5983 10.7437 29 12.246 29 13.8124V49.2495C29 50.816 29.5983 52.3182 30.6632 53.4258C31.7282 54.5335 33.1725 55.1557 34.6786 55.1557H63.0714C64.5775 55.1557 66.0218 54.5335 67.0868 53.4258C68.1517 52.3182 68.75 50.816 68.75 49.2495V13.8124C68.75 12.246 68.1517 10.7437 67.0868 9.63608C66.0218 8.52845 64.5775 7.90619 63.0714 7.90619H57.3929M40.3571 7.90619C40.3571 9.47261 40.9554 10.9749 42.0204 12.0825C43.0853 13.1901 44.5297 13.8124 46.0357 13.8124H51.7143C53.2203 13.8124 54.6647 13.1901 55.7296 12.0825C56.7946 10.9749 57.3929 9.47261 57.3929 7.90619M40.3571 7.90619C40.3571 6.33977 40.9554 4.83751 42.0204 3.72988C43.0853 2.62226 44.5297 2 46.0357 2H51.7143C53.2203 2 54.6647 2.62226 55.7296 3.72988C56.7946 4.83751 57.3929 6.33977 57.3929 7.90619",
    stroke: "#131415",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.5,
    y1: 25.9859,
    x2: 49.5,
    y2: 38.9859,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56.5,
    y1: 31.9859,
    x2: 42.5,
    y2: 31.9859,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPermitsLarge);
export default __webpack_public_path__ + "static/media/ico_permits_large.3e0156059aff2ed02d5feae1a9742a74.svg";
export { ForwardRef as ReactComponent };